import React from 'react'
import styled, {keyframes} from 'styled-components';
import UpperBody from './upperBody';
import PlainHead from './PlainHead';
import Legs from './Legs';
import HeadPolice from './head/HeadPolice';
import Beanie from './head/Beanie';
import Blue from './head/Blue';
import Deer from './head/Deer';
import Disco from './head/Disco';
import Glasses from './head/Glasses';
import Queen from './head/Queen';
import Scarf from './head/Scarf';
import Xmas from './head/Xmas';
import Bruce from './body/Bruce';
import Black from './body/Black';
import Ballet from './body/Ballet';
import Gift from './body/Gift';
import Lace from './body/Lace';
import Pink from './body/Pink';
import Santa from './body/Santa';
import Stick from './body/Stick';
import Sweater from './body/Sweater';
import Tree from './body/Tree';
import V from './body/V';
import BodyXmas from './body/Xmas';
import Tshirt from './body/Tshirt';
import LegBallet from './leg/Ballet';
import Boxer from './leg/Boxer';
import BodyLeg from './leg/Bruce';
import Fairy from './leg/Fairy';
import Jersey from './leg/Jersey';
import BodyLace from './leg/Lace';
import Pant from './leg/Pant';
import BodySanta from './leg/Santa';
import Superman from './leg/Superman';
import BodySweater from './leg/Sweater';
import Tight from './leg/Tight';
import Under from './leg/Under';

const bouncy = keyframes`
  0% {
    transform: translateX(0);
  }
  10% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(-6px);
  }
  60% {
    transform: translateX(13px);
  }
  75% {
    transform: translateX(6px);
  }
  88% {
    transform: translateX(8px);
  }
  100% {
    transform: translateX(0);

  }
`;


const HeadContainer = styled.div`
z-index: 3;
position:relative;
  ${({width, translateX }) => width && `
    width: ${width}px;
    > div {
      transform: translateX(${translateX || '50%'});
    }
  `}
  ${({ selected }) => selected && `
  `}
  animation:  ${bouncy} 1s linear infinite;
  ${({ animated }) => !animated && `
    animation: none;
  `}
  ${({editable }) => editable && `
    cursor: pointer;
    transition: 0.1s ease-in;
    &:hover {
      transform: translateY(5px);
    }
    `}
`;
const BodyContainer = styled.div`
z-index: 2;
  margin-top: ${({attached }) => attached ? `-11px` : `-25px`} ;
  position: relative;
    max-height: 270px;
  ${({editable }) => editable && `
  cursor: pointer;
  transition: 0.1s ease-in;
  &:hover {
    transform: translateY(5px);
  }
  `}
`;
// > div {
//   position: absolute;
//   transform: translateX(50%) scale(0.95)
// }

const LegsContainer = styled.div`
  min-height: 300px;
  position: relative;
  margin-top: ${({ attached }) => attached ? 0 : `-10px`};
  z-index: 1;
  ${({width}) => width && `
    width: ${width}px;
    > div {
      transform: translateX(49%) translateY(-10px) scale(0.9);
    }
  `}
  ${({editable }) => editable && `
  cursor: pointer;
  transition: 0.1s ease-in;
  &:hover {
    transform: translateY(-5px);
  }
  `}

`;
const Choices = styled.div`
position: absolute;
top: 0;
left: -200px;
background: #fff;
border-radius:8px;
padding: 10px;
max-height: 500px;
width: 150px;
overflow-y: auto;
overflow-x: hidden;
`;
const ChoiceBox =  styled.div`
  width: 100px;
  display: inline-block;
  cursor: pointer;
  animation: ${bouncy} 1s linear infinite;
`

const HEADS = [
  {component: PlainHead, key: 'default'},
  {component: HeadPolice, key: 'police'},
  {component: Beanie, key: 'beanie'},
  {component: Blue, key: 'blue'},
  {component: Deer, key: 'deer'},
  {component: Disco, key: 'disco'},
  {component: Glasses, key: 'glasses'},
  {component: Queen, key: 'queen'},
  {component: Scarf, key: 'scarf'},
  {component: Xmas, key: 'xmas'},
];
const BODY = [
  {component: UpperBody, key: 'default'},
  {component: Bruce, key: 'bruce'},
  {component: Ballet, key: 'ballet', transform: `translateX(4px) translateY(-158px) scale(1.11)`},
  {component: Black, key: 'black'},
  {component: Gift, key: 'gift'},
  {component: Lace, key: 'lace'},
  {component: Pink, key: 'pink'},
  {component: Santa, key: 'santa'},
  {component: Stick, key: 'stick', transform: `translateX(18px)`},
  {component: Sweater, key: 'sweater'},
  {component: Tree, key: 'tree'},
  {component: V, key: 'v'},
  {component: BodyXmas, key: 'xmas'},
  {component: Tshirt, key: 'Tshirt'}
];

const LEGS = [
  {component: Legs, key: 'default'},
  {component: LegBallet, key: 'LegBallet', transform: `translateX(51%) translateY(48px) scale(1.85)`},
  {component: Boxer, key: 'Boxer'},
  {component: BodyLeg, key: 'BodyLeg'},
  {component: Fairy, key: 'Fairy'},
  {component: Jersey, key: 'Jersey'},
  {component: BodyLace, key: 'BodyLace'},
  {component: Pant, key: 'Pant'},
  {component: BodySanta, key: 'BodySanta'},
  {component: Superman, key: 'Superman'},
  {component: BodySweater, key: 'BodySweater'},
  {component: Tight, key: 'Tight'},
  {component: Under, key: 'Under'},
];

const Content = ({width = 200, flipped = false,animated=false, variant = 'default',
  editable=false,
  handleSaveState,
  initialValues = {},

}) => {
const [partOnEdit, setPartOnEdit] = React.useState();

const handleSetActivePart = React.useCallback((part) => {
if (!editable) return;
setPartOnEdit(prev => prev === part ? undefined : part);
}, [editable])

const [head, setHead] = React.useState(initialValues.head || 'default');
const [body, setBody] = React.useState(initialValues.body || 'default');
const [legs, setLegs] = React.useState(initialValues.legs || 'default');

const handleSetPart = React.useCallback((part, value)=> {
  let method;
  if (part === 'head') {
    method = setHead;
  } else if (part === 'body') {
    method = setBody;
  } else if (part === 'legs') {
    method = setLegs
  }
  if (method) {
    method(value);
  }
  if (handleSaveState) {
    handleSaveState(part, value)
  }
  setPartOnEdit()
}, [setPartOnEdit, setHead, handleSaveState])

const headComponent = React.useMemo(() => {
  const headItem = HEADS.find(h => h.key === head);
  if (!headItem) return <PlainHead />;
  const {component:Component} = headItem
  return <Component />;
}, [head])

const bodyComponent = React.useMemo(() => {
  const bodyItem = BODY.find(h => h.key === body);
  if (!bodyItem) return <UpperBody />;
  const {component:Component, transform} = bodyItem
  return <div style={{transform}}><Component /></div>
}, [body]);

const legsComponent = React.useMemo(() => {
  const legItem = LEGS.find(h => h.key === legs);
  if (!legItem) return <Legs />;
  const {component:Component, transform} = legItem
  return <div style={{transform}}><Component /></div>
}, [legs]);

return (
      <div style={{ width: `${width}px`, height:'fit-content', opacity: flipped ? 0.5 : 1 }}>
        {partOnEdit === 'head' && (
            <Choices>
              {HEADS.map(({component:Comp, key}) => {
                return <ChoiceBox  key={key} onClick={() => handleSetPart('head', key)} >
                  <Comp  />
                </ChoiceBox>
              })}
            </Choices>
          )}
        {partOnEdit === 'body' && (
            <Choices>
              {BODY.map(({component:Comp, key}) => {
                return <ChoiceBox  key={key} onClick={() => handleSetPart('body', key)} >
                  <Comp  />
                </ChoiceBox>
              })}
            </Choices>
          )}
        {partOnEdit === 'legs' && (
            <Choices>
              {LEGS.map(({component:Comp, key}) => {
                return <ChoiceBox key={key} onClick={() => handleSetPart('legs', key)} >
                  <Comp  />
                </ChoiceBox>
              })}
            </Choices>
          )}
        <HeadContainer animated={animated} editable={editable}
        width={variant !== 'bigHead' ? width / 2 : width / 1.5}
        translateX={variant !== 'bigHead' ? '50%' : '25%'}
        onClick={() => handleSetActivePart('head')}
        selected={partOnEdit === 'head' }
        >
          {headComponent}
        </HeadContainer>
        <BodyContainer
        editable={editable}
        attached={variant === 'bigHead'}
        onClick={() => handleSetActivePart('body')}>
          {bodyComponent}
        </BodyContainer>
        <LegsContainer
                editable={editable}
                attached={variant === 'bigHead'}
                width={width / 2} onClick={() => handleSetActivePart('legs')}>
          {legsComponent}
        </LegsContainer>
      </div>
  )
}
export default Content;